<template>
  <table width="100%" border="0" cellspacing="0" cellpadding="0" class="byl-table">
    <thead>
    <tr class="list_tit">
      <td width="25" v-if="opts.checkboxMode"><input id="sel_1" type="checkbox" v-model="allChecked" /></td>
      <td v-for="item in model.columns" :key="item.field" :width="item.colWidth">
        <span>{{item.title}}</span>
      </td>
      <td v-if="model.actions && model.actions.length > 0">操作</td>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, idx) in model.data" :key="idx">
      <td v-if="opts.checkboxMode" class="pl10"><input type="checkbox" :value="item" v-model="checked" /></td>
      <td v-for="key in getColumnsFields" :key="key">
        {{item[key]}}
      </td>
      <td v-if="model.actions && model.actions.length > 0">
        <slot v-for="i in model.actions" :name="i" :item="item"></slot>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'byl-table',
  data () {
    return {
      internalColumns: [],
      checked: []
    }
  },
  methods: {
    initInternalColumns () {
      return Array.isArray(this.model.columns) ? this.model.columns : []
    },
    sendTo (evt, val) {
      this.$emit(evt, val)
    }
  },
  mounted () {
    this.internalColumns = this.initInternalColumns()
  },
  watch: {
    checked (val) {
      this.$emit('table-selected', val)
    }
  },
  computed: {
    getColumnsFields () {
      return this.internalColumns.map((item) => {
        return item.field
      })
    },
    allChecked: {
      get () {
        if (this.model.data) {
          return this.checkedCount == this.model.data.length
        }
        return false
      },
      set (value) {
        if (value) {
          this.checked = this.model.data.map(function (item) {
            return item
          })
        } else {
          this.checked = []
        }
      }
    },
    checkedCount: {
      get: function () {
        return this.checked.length;
      }
    }
  },
  props: {
    model: {
      type: Object,
      default () {
        return {
          columns: [],
          data: []
        }
      }
    },
    opts: {
      type: Object,
      default () {
        return {
          checkboxMode: true
        }
      }
    }
  }
}
</script>
<style scoped>
  @import './index.css';
  .xo-table-btn {
    padding: 5px;
    margin-right: 3px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/table/index.vue